import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "../src/Home"
import { useEffect, useState, useRef } from "react";
import Navbar from "../src/Global/Navbar";
import Head from "../src/Global/Header_for_mobile";
import Footer from "../src/Global/Footer";
import Foot from "../src/Global/Footer_for_mobile";
import IndexPage from "./HomePage/indexPage";
import Index from "../src/Home";
import IndexListPage from "./Listpage/IndexListPage";
import CabDetails from "./Home/CabDetails";
import IndexSeats from "./Seats/IndexSeats";
import Card from "./Home/Card";
import IndexBooking from "./BookingConfirmation/indexBooking";
import IndexUser from "./UserProfile/IndexUser";
import Signin from "./Register/Signin";
import Signup from "./Register/Signup";
import TermsandCondition from "./UserProfile/TermsandCondition";
import IndexFull from "./FullCars/IndexFull";
import IndexFullcab from "./FullCabBooking/IndexFullcab";
import FullCarBookingConfirmed from "./FullCabBooking/FullCarBookingConfirmed";
import IndexHomemobile from "./HomeMobile/IndexHomemobile";
import IndexHotel from "./Hotel/IndexHotel";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { TbSos } from "react-icons/tb";
import { IndexPackages } from "./packages/IndexPackages";
import Detailedbooking from "./UserProfile/booking";
import Aboutus from "./Global/aboutus";
import Fullcabbook from "./Seats/fullcabseats";
import CareersPage from "./Careers/careers";
import JobDetails from "./Careers/jobDetails";
import JobApplyForm from "./Careers/applyForm";
import RequestPermission from "../src/Shared/requestPermission";
import NotificationInit from "../src/Shared/NotificationInit";
import { IndexOffers } from "./packages/IndexPackages";
import { useSelector } from "react-redux";
import CorporateBookings from "./Home/corporateBookings";
export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { token, user, isAuthenticate } = useSelector(
    (state) => state.userauth
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  console.log("🤗🙂 User auth status", user);

  // useEffect(() => {
  //   const registerServiceWorker = async () => {
  //     if ("serviceWorker" in navigator) {
  //       try {
  //         const registration = await navigator.serviceWorker.register(
  //           "/sw.js",
  //           { scope: "/" }
  //         );
  //         console.log(
  //           registration.installing
  //             ? "Service worker installing"
  //             : registration.waiting
  //             ? "Service worker installed"
  //             : "Service worker active"
  //         );
  //       } catch (error) {
  //         console.error(`Registration failed with ${error}`);
  //       }
  //     }
  //   };
  //   registerServiceWorker();
  // }, []);

  const WhatsAppButton = () => {
    const [showOptions, setShowOptions] = useState(false);
    const buttonRef = useRef(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);

    const phoneNumber = "+919883587965";

    const handleMouseDown = (e) => {
      setIsDragging(true);
      const button = buttonRef.current;
      const rect = button.getBoundingClientRect();
      button.offset = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const x = e.clientX - buttonRef.current.offset.x;
      const y = e.clientY - buttonRef.current.offset.y;
      setPosition({ x, y });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    // Attach event listeners to window
    if (typeof window !== "undefined") {
      window.onmousemove = handleMouseMove;
      window.onmouseup = handleMouseUp;
    }

    return (
      <div
        ref={buttonRef}
        onMouseDown={handleMouseDown}
        style={{
          position: "fixed",
          left: position.x || "auto",
          top: position.y || "auto",
          bottom: position.y === 0 ? "13rem" : "auto",
          right: position.x === 0 ? "1.25rem" : "auto",
          zIndex: 9999,
          cursor: "grab",
        }}
        className="flex flex-col items-end gap-2"
      >
        <div className="relative flex flex-col items-end gap-3">
          {showOptions && (
            <>
              <a
                href={`https://wa.me/${phoneNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="sos-option animate-slide-fade bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300"
                title="WhatsApp"
              >
                <FaWhatsapp size={20} />
              </a>
              <a
                href={`tel:${phoneNumber}`}
                className="sos-option animate-slide-fade bg-blue-500 text-white p-3 rounded-full shadow-lg hover:bg-blue-600 transition-all duration-300"
                title="Call"
              >
                <FaPhoneAlt size={20} />
              </a>
            </>
          )}
          <button
            onClick={() => setShowOptions(!showOptions)}
            className="bg-white text-black p-4 rounded-full shadow-lg hover:bg-gray-300 transition-all duration-300 flex items-center justify-center"
            title="SOS"
          >
            <TbSos size={24} />
          </button>
        </div>

        {/* CSS Animations */}
        <style jsx>{`
          .animate-slide-fade {
            animation: slideFadeIn 0.3s ease-out;
          }

          @keyframes slideFadeIn {
            0% {
              opacity: 0;
              transform: translateY(10px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <div>{isMobile ? <Head /> : <Navbar />}</div>

        <div className="flex-grow">
          <Routes>
            {/* <Route path="/" element={<IndexHomemobile />} /> */}
            <Route path="/" element={<IndexPage/>} />
            <Route path="/bookCabs" element={<Index />} />
            <Route path="/sharedcabs" element={<IndexListPage />} />
            <Route path="/Seats/:vid" element={<IndexSeats />} />
            <Route path="/packages" element={<IndexPackages />} />
            <Route
              path="/sharedcabbookingconfirmed"
              element={<IndexBooking />}
            />
            <Route path="/userprofile" element={<IndexUser />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsandCondition />}
            />
            <Route path="/fullcars" element={<IndexFull />} />
            <Route path="/fullcabbooking" element={<IndexFullcab />} />
            <Route path="/fullcabbook/:id" element={<Fullcabbook />} />
            <Route path="/detailedbooking" element={<Detailedbooking />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route
              path="/fullcabbookingconfirmed"
              element={<FullCarBookingConfirmed />}
            />
            <Route path="/home" element={<IndexHomemobile />} />
            <Route path="/hotels" element={<IndexHotel />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/job-details/:id" element={<JobDetails />} />
            <Route path="/careers/apply/:id" element={<JobApplyForm />} />
            <Route path="/corporate-bookings" element={<CorporateBookings />} />
          </Routes>
        </div>
        <div>{isMobile ? <Foot /> : <Footer />}</div>
        <WhatsAppButton />
        <>
         <div><NotificationInit /></div> 
          
        </>
      </div>
    </>
  );
}
